import React, { useMemo } from "react";

const AboutValues = () => {
  const values = useMemo(
    () => [
      {
        title: "People-focused",
        desc: "We design for real teams, real constraints, and real adoption.",
        icon: (
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
            <path d="M7 19C7 16.8 9 15 12 15C15 15 17 16.8 17 19" stroke="var(--brand)" strokeWidth="2" />
            <path d="M12 12C10.3 12 9 10.7 9 9C9 7.3 10.3 6 12 6C13.7 6 15 7.3 15 9C15 10.7 13.7 12 12 12Z" stroke="var(--brand-accent)" strokeWidth="2" />
          </svg>
        )
      },
      {
        title: "Process-centric",
        desc: "Clear standards and routines reduce risk and stabilize outcomes.",
        icon: (
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
            <path d="M7 7H17M7 12H17M7 17H13" stroke="var(--brand)" strokeWidth="2" strokeLinecap="round" />
            <path d="M5 5H19V19H5V5Z" stroke="var(--brand-accent)" strokeWidth="2" />
          </svg>
        )
      },
      {
        title: "Outcome-driven",
        desc: "We measure results and build systems that keep gains over time.",
        icon: (
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
            <path d="M4 19V5M4 19H20" stroke="var(--brand)" strokeWidth="2" strokeLinecap="round" />
            <path d="M7 15L11 11L14 14L20 8" stroke="var(--brand-accent)" strokeWidth="2" strokeLinecap="round" />
          </svg>
        )
      }
    ],
    []
  );

  return (
    <section id="values" className="relative w-full overflow-hidden bg-[color:var(--surface)]">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -right-40 h-[34rem] w-[34rem] rounded-full bg-[color:var(--brand)]/10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-semibold text-[color:var(--navy)]">
            Values that guide our work
          </h2>
          <p className="mt-3 text-[color:var(--muted)]">
            A disciplined approach that teams can sustain.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {values.map((v) => (
            <div
              key={v.title}
              className="group rounded-2xl border border-[color:var(--border)] bg-white p-8 transition hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex items-center gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-[color:var(--surface)] border border-[color:var(--border)] group-hover:scale-105 transition">
                  {v.icon}
                </div>
                <div className="text-xl font-semibold text-[color:var(--navy)]">
                  {v.title}
                </div>
              </div>
              <p className="mt-4 text-sm text-[color:var(--muted)] leading-relaxed">
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutValues;
